import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView.attrs({
  showsVerticalScrollIndicator: false,
  contentContainerStyle: {flexGrow: 1, paddingBottom: RFValue(24)},
})`
  flex: 1;

`;

/* ─── Header Banner ─── */

export const Banner = styled.View`
  background-color: ${({theme}) => theme.colors.loan_banner_bg};
  padding: ${RFValue(20)}px 24px ${RFValue(24)}px;
  align-items: center;
`;

export const BackButton = styled.TouchableOpacity`
  position: absolute;
  top: ${RFValue(12)}px;
  left: 16px;
  z-index: 10;
  width: ${RFValue(36)}px;
  height: ${RFValue(36)}px;
  border-radius: ${RFValue(18)}px;
  background-color: ${({theme}) => theme.colors.loan_banner_overlay};
  align-items: center;
  justify-content: center;
`;

export const BackIcon = styled(Feather)`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.loan_banner_text};
`;

export const BannerIconWrapper = styled.View`
  width: ${RFValue(56)}px;
  height: ${RFValue(56)}px;
  border-radius: ${RFValue(28)}px;
  background-color: ${({theme}) => theme.colors.loan_banner_overlay};
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(12)}px;
  margin-top: ${RFValue(8)}px;
`;

export const BannerIcon = styled(Feather)`
  font-size: ${RFValue(26)}px;
  color: ${({theme}) => theme.colors.loan_banner_text};
`;

export const BannerTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.loan_banner_text};
  text-align: center;
`;

export const BannerSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.loan_banner_text_secondary};
  text-align: center;
  margin-top: ${RFValue(6)}px;
  line-height: ${RFValue(18)}px;
`;

/* ─── Summary Card ─── */

export const SummaryCard = styled.View`
  margin: ${RFValue(-16)}px 24px 0;
  padding: ${RFValue(16)}px;
  border-radius: ${RFValue(14)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
  elevation: 3;
  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.08;
  shadow-radius: 6px;
`;

export const SummaryRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(6)}px;
`;

export const SummaryLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const SummaryValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const Divider = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border};
  margin: ${RFValue(8)}px 0;
`;

/* ─── Checkbox ─── */

export const CheckboxRow = styled.TouchableOpacity`
  flex-direction: row;
  align-items: flex-start;
  margin: ${RFValue(16)}px 24px 0;
  padding: ${RFValue(12)}px ${RFValue(14)}px;
  border-radius: ${RFValue(10)}px;
  background-color: ${({theme}) => theme.colors.price_card};
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
`;

export const CheckboxBox = styled.View<{checked: boolean}>`
  width: ${RFValue(22)}px;
  height: ${RFValue(22)}px;
  border-radius: ${RFValue(6)}px;
  border-width: 2px;
  border-color: ${({theme, checked}) =>
    checked ? theme.colors.primary : theme.colors.silver};
  background-color: ${({theme, checked}) =>
    checked ? theme.colors.primary : 'transparent'};
  align-items: center;
  justify-content: center;
  margin-right: ${RFValue(10)}px;
  margin-top: ${RFValue(1)}px;
`;

export const CheckboxIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.loan_banner_text};
`;

export const CheckboxText = styled.Text`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  line-height: ${RFValue(18)}px;
`;

/* ─── Footer ─── */

export const Footer = styled.View`
  padding: ${RFValue(12)}px 24px;
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
  background-color: ${({theme}) => theme.colors.background};
`;

/* ─── OTP Section ─── */

export const OtpSection = styled.View`
  padding: ${RFValue(20)}px 24px;
  margin: ${RFValue(-16)}px 24px 0;
  border-radius: ${RFValue(14)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
  elevation: 3;
  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.08;
  shadow-radius: 6px;
  align-items: center;
`;

export const OtpIconWrapper = styled.View`
  width: ${RFValue(64)}px;
  height: ${RFValue(64)}px;
  border-radius: ${RFValue(32)}px;
  background-color: ${({theme}) => theme.colors.loan_otp_icon_bg};
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(16)}px;
`;

export const OtpIcon = styled(Feather)`
  font-size: ${RFValue(28)}px;
  color: ${({theme}) => theme.colors.loan_otp_icon};
`;

export const OtpTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(8)}px;
`;

export const OtpDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  line-height: ${RFValue(18)}px;
  margin-bottom: ${RFValue(16)}px;
`;

export const OtpNoticeCard = styled.View`
  flex-direction: row;
  align-items: flex-start;
  background-color: ${({theme}) => theme.colors.loan_otp_icon_bg};
  border-radius: ${RFValue(10)}px;
  padding: ${RFValue(12)}px ${RFValue(14)}px;
  margin-bottom: ${RFValue(16)}px;
  width: 100%;
`;

export const OtpNoticeIcon = styled(Feather)`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.loan_otp_icon};
  margin-right: ${RFValue(10)}px;
  margin-top: ${RFValue(1)}px;
`;

export const OtpNoticeText = styled.Text`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text_dark};
  line-height: ${RFValue(17)}px;
`;

export const OtpCodeContainer = styled.View`
  width: 100%;
  margin-bottom: ${RFValue(16)}px;
`;

export const OtpTokenInput = styled.TextInput`
  width: 100%;
  height: ${RFValue(48)}px;
  border-radius: ${RFValue(10)}px;
  border-width: 2px;
  border-color: ${({theme}) => theme.colors.border};
  background-color: ${({theme}) => theme.colors.background};
  padding: 0 ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
  
`;

export const OtpResendRow = styled.View`
  flex-direction: row;
  align-items: center;
  margin-top: ${RFValue(8)}px;
`;

export const OtpErrorText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.attention};
  text-align: center;
  margin-bottom: ${RFValue(8)}px;
`;

/* ─── Success ─── */

export const SuccessContainer = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
  align-items: center;
  justify-content: center;
  padding: 0 32px;
`;

export const SuccessIconWrapper = styled.View`
  width: ${RFValue(80)}px;
  height: ${RFValue(80)}px;
  border-radius: ${RFValue(40)}px;
  background-color: ${({theme}) => theme.colors.primary_light};
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(20)}px;
`;

export const SuccessIconCheck = styled(Feather)`
  font-size: ${RFValue(38)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const SuccessTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(10)}px;
`;

export const SuccessSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  line-height: ${RFValue(20)}px;
`;

export const SuccessInfoCard = styled.View`
  margin-top: ${RFValue(24)}px;
  padding: ${RFValue(16)}px;
  border-radius: ${RFValue(14)}px;
  background-color: ${({theme}) => theme.colors.price_card};
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
  width: 100%;
`;

export const SuccessInfoRow = styled.View`
  flex-direction: row;
  align-items: center;
  margin-bottom: ${RFValue(10)}px;
`;

export const SuccessInfoIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.primary};
  margin-right: ${RFValue(10)}px;
`;

export const SuccessInfoText = styled.Text`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  line-height: ${RFValue(18)}px;
`;

export const DisclaimerText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.text};
  margin: ${RFValue(8)}px 24px 0;
  line-height: ${RFValue(15)}px;
`;

/* ─── Authorization Modal ─── */

export const ModalOverlay = styled.View`
  flex: 1;
  background-color: rgba(0, 0, 0, 0.55);
  justify-content: center;
  align-items: center;
  padding: 0 24px;
`;

export const ModalCard = styled.View`
  width: 100%;
  border-radius: ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.background};
  padding: ${RFValue(24)}px;
  align-items: center;
`;

export const ModalIconWrapper = styled.View`
  width: ${RFValue(52)}px;
  height: ${RFValue(52)}px;
  border-radius: ${RFValue(26)}px;
  background-color: ${({theme}) => theme.colors.loan_otp_icon_bg};
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(16)}px;
`;

export const ModalIcon = styled(Feather)`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.loan_otp_icon};
`;

export const ModalTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(12)}px;
`;

export const ModalText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  line-height: ${RFValue(19)}px;
  margin-bottom: ${RFValue(20)}px;
`;

export const ModalButtonRow = styled.View`
  width: 100%;
  flex-direction: row;
  gap: ${RFValue(10)}px;
`;

export const ModalCancelButton = styled.TouchableOpacity`
  flex: 1;
  height: ${RFValue(44)}px;
  border-radius: ${RFValue(10)}px;
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
  align-items: center;
  justify-content: center;
`;

export const ModalCancelText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const ModalConfirmButton = styled.TouchableOpacity`
  flex: 1;
  height: ${RFValue(44)}px;
  border-radius: ${RFValue(10)}px;
  background-color: ${({theme}) => theme.colors.primary};
  align-items: center;
  justify-content: center;
`;

export const ModalConfirmText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.buttonTitle};
`;
